import { combineReducers } from 'redux';
import { createLoadingReducer, createListLoadingReducer } from './utils';

export default combineReducers({
    systemSettings: createLoadingReducer('SYSTEM_SETTINGS'),
    errors: createListLoadingReducer('ERROR_CHECK'),
});
